import { BaseLayoutFactory } from "../global/base-layout-factory";
import { OfficialDailyDetailProvider } from "./context/official-daily-detail-context";
import { OfficialDailyDetailComponent } from "./official-daily-detail-component";

export function OfficialDailyDetailFactory() {
  return (
    <BaseLayoutFactory>
      <OfficialDailyDetailProvider>
        <OfficialDailyDetailComponent />
      </OfficialDailyDetailProvider>
    </BaseLayoutFactory>
  );
}
